module.exports = __webpack_public_path__ + "img/select-icon2.be127397.png";